import script from "./actionParamWizard.vue?vue&type=script&lang=js"
export * from "./actionParamWizard.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__